// import Parsley from 'parsleyjs';
// import cash from 'cash-dom';

import { initializeFirebase } from './utils.js';

(function($) {
	$(document).ready(function() {

    // Initialize Firebase app with configuration from WordPress
    // Use shared utility function to handle initialization safely
    initializeFirebase('home.js');

		const $theList = $('#theList');

		// shows (added to window in content-list.php)
		const showSearchData = window.upcomingShows ? Object.values(window.upcomingShows) : [];

		// global vairables for filters/search
		let selectedVenue = $('#venueFilter').val();
		let searchedShows = null;

		$theList.on('eval-filters', function() {
			_handleFilters();
		});

		function _handleFilters() {
			_resetList();

			const hasSelectedVenue = selectedVenue && selectedVenue !== 'all';
			const hasSearchedShows = Boolean(searchedShows);

			if (hasSelectedVenue || hasSearchedShows) {
				if (hasSelectedVenue) {
					_hideByVenue(selectedVenue);
				}

				if (hasSearchedShows) {
					const ids = searchedShows.map(show => show.id);
					_hideByShowIds(ids);
				}

				_hasResults();
				_hideMobileAds();

        // hide date headers for each day section
        // when there are no shows showing in them
				$(".showlist-item:hidden")
          .closest('.show-date')
          .not( $(".showlist-item:visible")
          .closest('.show-date') )
          .hide();

				if ($('.showlist-item:hidden').length === showSearchData.length) {
					_noResults();
				}
			} else {
				_hasResults();
			}
		}

		// filters open
		$('.filters-btn').on('click', function() {
			$(this).toggleClass('closed');
			$('.filters-open-indicator').toggle();
      $('.filters-container').toggleClass('open');
		});

		// text search
		$('#show-search').on('input', function(e) {
			const theSearchString = $(this).val().toLowerCase() || '';

			if (!theSearchString.length || theSearchString.length < 3) {
				searchedShows = null;
				$theList.trigger('eval-filters');
				return;
			}

			const searchResults = showSearchData.filter(show => {
				return show.title.toLowerCase().includes(theSearchString);
			});

			searchedShows = searchResults;

			$theList.trigger('eval-filters');
		});

		$('.clear-all-filters').on('click', function() {
			_resetFilters();
			$theList.trigger('eval-filters');
		});

		function _resetFilters() {
			_clearSearch();
			_clearVenueFilter();
		}

		function _clearVenueFilter() {
			$('#venueFilter').val('all');
			selectedVenue = 'all';
		}

		function _clearSearch() {
			$('#show-search').val('');
			searchedShows = null;
		}

		function _noResults() {
			$('.title-section').hide();
			$('#noResults').show();

			_hideTopMessage();
		}

		function _hasResults() {
			$('.title-section').show();
			$('#noResults').hide();

			_hideTopMessage();
		}

		function _hideTopMessage() {
			$('.home-top-message').hide();
		}

		function _resetList() {
			$('.title-section').show();
			$('.showlist-item').show();
			$('.show-date').show();
			_showMobileAds();
		}

		function _hideMobileAds() {
			$('.mobile-ad').removeClass('d-flex').addClass('d-none');
		}

		function _showMobileAds() {
			$('.mobile-ad').removeClass('d-none').addClass('d-flex');
		}

		function _hideByVenue(venueName) {
			$('.showlist-item:not([data-venue="'+ venueName +'"])').hide();
		}

		// hide shows that don't match the showIds
		function _hideByShowIds(showIds) {
			const showsToHide = showSearchData.filter(show => {
				return !showIds.includes(show.id);
			});

			showsToHide.forEach(show => {
				$('.showlist-item[data-show-id="'+ show.id +'"]').hide();
			});
		}

		$(document).on('click', '.clear-search-btn', function() {
			_clearSearch();
			$theList.trigger('eval-filters');
		});

		// showlist venue filter
		$(document).on('change', '#venueFilter', function() {
			selectedVenue = $(this).val();
			$theList.trigger('eval-filters');

			if (site.env === 'production' && site.loggedIn !== '1') {
				gtag('event', 'click', {
					'event_category': 'filters',
					'event_label': 'venue selected',
					'event_value': selectedVenue,
					'send_to': 'UA'
				});

				gtag('event', 'click', {
					'click_type': 'filters',
					'click_action': 'venue selected',
					'click_value': selectedVenue,
					'send_to': 'GA4'
				});
			}
		});

		// Spotify Player

		// hide the spotify player when someone scrolls all the way to the bottom
		$(window).on('scroll', function() {
			if($(window).scrollTop() + $(window).height() == $(document).height()) {
				$('.spotify-action-btn, .spotify-wrapper').fadeOut('fast');
			} else {
				$('.spotify-action-btn, .spotify-wrapper').fadeIn('fast');
			}
		});

    // show spotify click trigger
    document.querySelector('.spotify-action-btn')?.addEventListener('click', function() {
      document.querySelector('.spotify-wrapper')?.classList.toggle('open');
    });

    // END - Spotify Player
	});
})(jQuery);
